export default __webpack_public_path__ + "static/media/Shopify_logo_2018.svg.bc312bdd.png";